// Reducer

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/util/action-type.util';
import { ACTION_TYPES } from './actions';
import { CmsState, initialState } from './state';
import { setStylesProperties } from 'app/shared/util/methode-util';

export default (state: CmsState = initialState, action): CmsState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_DOCUMENTS):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_DOCUMENTS): {
      const key = action.payload.type;
      const data = action?.payload?.docs?.data;
      const isReady = !state.isReady ? key === 'app_global_type' : true;

      let document;
      if (data.results_size === 1) {
        document = data.results[0];
      } else if (data.results_size > 1) {
        document = data.results;
      }

      const documents = { ...state.documents };
      documents[key] = document;

      return {
        ...state,
        documents,
        loading: false,
        isReady,
      };
    }
    case FAILURE(ACTION_TYPES.GET_DOCUMENTS): {
      return {
        ...state,
        loading: false,
      };
    }
    case ACTION_TYPES.IS_READY: {
      return {
        ...state,
        isReady: true,
      };
    }
    default:
      return state;
  }
};
